import { theme } from "../../theme";

export const reservationClasses = {
  contentWrapper: {
    height: "calc(100vh - 255px)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: "460px",
  },
  listContent: {
    overflow: "auto",
  },
  searchButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: "5px",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: "5px",
  },
  topFilters: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  searchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
    border: 0,
    boxShadow: "none",
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    "&.MuiFormControl-root": {
      m: 0,
    },
    "& .MuiInputBase-root": {
      padding: "9px 10px 9px 10px",
      borderTopRightRadius: "0 !important",
      borderBottomRightRadius: "0 !important",
    },
  },
  clearIcon: {
    cursor: "pointer",
    marginRight: "10px",
  },
  listTextCss: {
    component: "span",
    fontWeight: "bold",
    fontSize: "16px",
    display: "inline-block",
    mr: 1,
  }
} as const;
